// NG2
import { Component } from '@angular/core';

@Component({
  selector: 'novo-table-actions',
  template: '<ng-content></ng-content>',
})
export class NovoTableActionsElement {}
